__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = undefined;
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@elixir/auth", "3.0.120", () => (() => (__webpack_require__(31969))), 1);
			register("@elixir/components", "3.0.120", () => (() => (__webpack_require__(32827))), 1);
			register("@elixir/components", "3.0.142", () => (() => (__webpack_require__(34418))), 1);
			register("@elixir/fx", "3.0.120", () => (() => (__webpack_require__(17738))), 1);
			register("@engagehub/core", "1.1.1002-alpha04", () => (() => (__webpack_require__(88157))), 1);
			register("@engagehub/core", "1.11.2292", () => (() => (__webpack_require__(8484))), 1);
			register("@fluentui/react-charting", "5.15.9", () => (() => (__webpack_require__(85512))), 1);
			register("@fluentui/react", "8.110.10", () => (() => (__webpack_require__(82534))), 1);
			register("@fluentui/theme", "2.6.24", () => (() => (__webpack_require__(66759))), 1);
			register("@fluentui/theme", "2.6.34", () => (() => (__webpack_require__(69182))), 1);
			register("@fluentui/theme", "2.6.34", () => (() => (__webpack_require__(4870))), 1);
			register("@fluentui/utilities", "8.13.18", () => (() => (__webpack_require__(80570))), 1);
			register("@reduxjs/toolkit", "1.9.1", () => (() => (__webpack_require__(42125))), 1);
			register("i18next", "19.8.4", () => (() => (__webpack_require__(42759))), 1);
			register("react-dom", "16.14.0", () => (() => (__webpack_require__(31542))), 1);
			register("react-i18next", "11.18.1", () => (() => (__webpack_require__(61242))), 1);
			register("react-query", "4.0.0-beta.17", () => (() => (__webpack_require__(21553))), 1);
			register("react-redux", "7.2.8", () => (() => (__webpack_require__(23884))), 1);
			register("react-router-dom", "5.3.3", () => (() => (__webpack_require__(4289))), 1);
			register("react-router", "5.3.3", () => (() => (__webpack_require__(69635))), 1);
			register("react", "16.14.0", () => (() => (__webpack_require__(27378))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};